import React, { useEffect, useState } from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import moment from 'moment';
import '../../TargetReport/TableContent/index.css';
import './operations.css';
import { Tooltip } from '@material-ui/core';

function TableContent({
  tableData,
  headerData,
  totalTableData,
  mediaCrescimento,
  updateMeta,
  setUpdateMetaData,
  setUpdateMeta,
  projecaoTableData,
  projecaoTotalTableData,
}) {
  const [model, setModel] = useState();
  const [bodyTableAntecipacao, setBodyTableAntecipacao] = useState();
  const [bodyTableEmpresa, setBodyTableEmpresa] = useState();
  const [bodyTableCapittale, setBodyTableCapittale] = useState();
  const [propertySorted, setPropertySorted] = useState({});
  const formatter = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const formatterPercent = new Intl.NumberFormat('pt-BR', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  useEffect(() => {
    if (tableData) {
      setTable(tableData);
      setTableEmpresa(tableData);
      setTableCapittale(tableData);
    }
  }, [tableData]);

  const toCurrency = (e) => {
    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span></span>
          <span style={{ widht: '80px' }}>{e ? formatter.format(e) : '0,00'}</span>
        </div>
      </>
    );
  };

  const sortTable = (table, param) => {
    switch (table) {
      case 1:
        setTable(tableData.sort(dynamicSort(param)));
        break;
      case 2:
        setTableEmpresa(tableData.sort(dynamicSort(param)));
        break;
      case 3:
        setTableCapittale(tableData.sort(dynamicSort(param)));
        break;
    }
  };

  function dynamicSort(property) {
    let sortOrder = 1;
    if (propertySorted[property] !== undefined) {
      sortOrder = propertySorted[property] * -1;
    }
    setPropertySorted((properties) => ({ ...properties, [property]: sortOrder }));
    return function (a, b) {
      const result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  const handleDateParams = () => {
    const date =  new Date(headerData.dataPagamento);
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return '1-' + month.toString() + '-' + year.toString();
  }

  const setTable = (data) => {
    localStorage.setItem('startRow', 1);
    setBodyTableAntecipacao(
      data.map(function (item, index) {
        let backColor = 'white';
        if (index % 2) {
          backColor = '#EEEEEE';
        }
        return (
          <>
            <TableRow style={{ backgroundColor: backColor }} key={index}>
              <Tooltip placement="top" title={
                item.analistas ? 
                <div dangerouslySetInnerHTML={{__html: item.analistas}}></div> : ''}
              >
                <TableCell size="small" align="left" style={{ cursor: 'pointer', color: 'black' }}>
                  <a
                    href={`/app/relatorios/mensal/${item.ancoraId === null ? '0' : item.ancoraId}/${handleDateParams()}`}
                    style={{ textDecoration: 'none', color: 'black' }}
                  >
                    {item?.apelido}
                  </a>
                </TableCell>
              </Tooltip>
              <TableCell size="small" align="left" style={{ borderLeft: 'none' }}></TableCell>
              <TableCell align="left" padding="dense">
                {toCurrency(item.mesDataPagamentoValorAntecipacoes)}
              </TableCell>
              <TableCell align="right">{toCurrency(item.dataPagamentoValorAntecipacoes)}</TableCell>
              <TableCell align="right">
                {toCurrency(item.dataPagamento2ValorAntecipacoes)}
              </TableCell>
              <TableCell align="right">
                {toCurrency(item.dataPagamento3ValorAntecipacoes)}
              </TableCell>
              <TableCell align="right">
                {toCurrency(item.dataPagamento4ValorAntecipacoes)}
              </TableCell>
              <TableCell align="right">
                {toCurrency(item.dataPagamento5ValorAntecipacoes)}
              </TableCell>
              <TableCell align="right">
                {toCurrency(item.dataPagamento6ValorAntecipacoes)}
              </TableCell>
              <TableCell align="right">
                {toCurrency(item.dataPagamento7ValorAntecipacoes)}
              </TableCell>
            </TableRow>
          </>
        );
      }),
    );
  };

  const bodyTableAntecipacaoTotal = (
    <>
      <TableRow style={{ height: '.8rem' }}>
        <TableCell></TableCell>
      </TableRow>
      <TableRow style={{ background: '#c4c4c4' }}>
        <TableCell align="left" style={{ color: 'black', fontWeight: 'bold' }}>
          Total
        </TableCell>
        <TableCell style={{ borderLeft: 'none' }}></TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.mesDataPagamentoValorAntecipacoes)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamentoValorAntecipacoes)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamento2ValorAntecipacoes)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamento3ValorAntecipacoes)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamento4ValorAntecipacoes)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamento5ValorAntecipacoes)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamento6ValorAntecipacoes)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamento7ValorAntecipacoes)}
        </TableCell>
      </TableRow>
      <TableRow style={{ height: '.8rem' }}>
        <TableCell></TableCell>
      </TableRow>
    </>
  );

  const setTableEmpresa = (data) => {
    localStorage.setItem('startRow', 1);
    setBodyTableEmpresa(
      data?.map(function (item, index) {
        let backColor = 'white';
        if (index % 2) {
          backColor = '#EEEEEE';
        }
        return (
          <>
            <TableRow style={{ backgroundColor: backColor }} key={index}>
              <Tooltip placement="top" title={
                item.analistas ? 
                <div dangerouslySetInnerHTML={{__html: item.analistas}}></div> : ''}
              >
                <TableCell colSpan={1} align="left">
                  {item.apelido}
                </TableCell>
              </Tooltip>
              <TableCell colSpan={1} style={{ borderLeft: 'none' }}></TableCell>
              <TableCell align="right">{toCurrency(item.mesDataPagamentoReceitaEmpresa)}</TableCell>
              <TableCell align="right">{toCurrency(item.dataPagamentoReceitaEmpresa)}</TableCell>
              <TableCell align="right">{toCurrency(item.dataPagamento2ReceitaEmpresa)}</TableCell>
              <TableCell align="right">{toCurrency(item.dataPagamento3ReceitaEmpresa)}</TableCell>
              <TableCell align="right">{toCurrency(item.dataPagamento4ReceitaEmpresa)}</TableCell>
              <TableCell align="right">{toCurrency(item.dataPagamento5ReceitaEmpresa)}</TableCell>
              <TableCell align="right">{toCurrency(item.dataPagamento6ReceitaEmpresa)}</TableCell>
              <TableCell align="right">{toCurrency(item.dataPagamento7ReceitaEmpresa)}</TableCell>
            </TableRow>
          </>
        );
      }),
    );
  };

  const bodyTableEmpresaTotal = (
    <>
      <TableRow style={{ height: '.8rem' }}>
        <TableCell></TableCell>
      </TableRow>
      <TableRow style={{ background: '#c4c4c4' }}>
        <TableCell align="left" style={{ color: 'black', fontWeight: 'bold' }}>
          Total
        </TableCell>
        <TableCell style={{ borderLeft: 'none' }}></TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.mesDataPagamentoReceitaEmpresa)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamentoReceitaEmpresa)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamento2ReceitaEmpresa)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamento3ReceitaEmpresa)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamento4ReceitaEmpresa)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamento5ReceitaEmpresa)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamento6ReceitaEmpresa)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamento7ReceitaEmpresa)}
        </TableCell>
      </TableRow>
      <TableRow style={{ height: '.8rem' }}>
        <TableCell></TableCell>
      </TableRow>
    </>
  );

  const setTableCapittale = (data) => {
    localStorage.setItem('startRow', 1);
    setBodyTableCapittale(
      data?.map(function (item, index) {
        let backColor = 'white';
        if (index % 2) {
          backColor = '#EEEEEE';
        }
        return (
          <>
            <TableRow style={{ backgroundColor: backColor }} key={index}>
              <Tooltip placement="top" title={
                item.analistas ? 
                <div dangerouslySetInnerHTML={{__html: item.analistas}}></div> : ''}
              >
                <TableCell align="left">{item.apelido}</TableCell>
              </Tooltip>
              <TableCell align="right">{formatterPercent.format(item.taxa / 100)}</TableCell>
              <TableCell align="right">
                {toCurrency(item.mesDataPagamentoReceitaCapittale)}
              </TableCell>
              <TableCell align="right">{toCurrency(item.dataPagamentoReceitaCapittale)}</TableCell>
              <TableCell align="right">{toCurrency(item.dataPagamento2ReceitaCapittale)}</TableCell>
              <TableCell align="right">{toCurrency(item.dataPagamento3ReceitaCapittale)}</TableCell>
              <TableCell align="right">{toCurrency(item.dataPagamento4ReceitaCapittale)}</TableCell>
              <TableCell align="right">{toCurrency(item.dataPagamento5ReceitaCapittale)}</TableCell>
              <TableCell align="right">{toCurrency(item.dataPagamento6ReceitaCapittale)}</TableCell>
              <TableCell align="right">{toCurrency(item.dataPagamento7ReceitaCapittale)}</TableCell>
            </TableRow>
          </>
        );
      }),
    );
  };

  const bodyTableCapittaleTotal = (
    <>
      <TableRow style={{ height: '.8rem' }}>
        <TableCell></TableCell>
      </TableRow>
      <TableRow style={{ background: '#c4c4c4' }}>
        <TableCell colSpan={2} align="left" style={{ color: 'black', fontWeight: 'bold' }}>
          Total
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.mesDataPagamentoReceitaCapittale)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamentoReceitaCapittale)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamento2ReceitaCapittale)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamento3ReceitaCapittale)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamento4ReceitaCapittale)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamento5ReceitaCapittale)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamento6ReceitaCapittale)}
        </TableCell>
        <TableCell
          align="right"
          style={{ color: 'black', fontWeight: 'bold', borderColor: '#c4c4c4' }}
        >
          {toCurrency(totalTableData?.dataPagamento7ReceitaCapittale)}
        </TableCell>
      </TableRow>
      <TableRow style={{ height: '.8rem' }}>
        <TableCell></TableCell>
      </TableRow>
    </>
  );

  return (
    <>
      <div
        className="report-tables"
        style={{
          margin: '20px 50px',
          zIndex: '0',
          position: 'relative',
          justifyContent: 'start',
          flexWrap: 'wrap',
          display: headerData ? 'flex' : 'none',
        }}
      >
        {/* Antecipação */}
        <Table
          style={{
            margin: '15px',
            backgroundColor: 'white',
            boxShadow:
              '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
          }}
        >
          <TableHead style={{ backgroundColor: '#232C63', width: '50%' }}>
            <TableRow>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} colSpan={10}>
                Antecipação
              </TableCell>
            </TableRow>
            {headerData?.itens?.length > 0 && (
              <TableRow>
                <TableCell
                  colSpan={2}
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(1, 'apelido')}
                >
                  Rede
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(1, 'mesDataPagamentoValorAntecipacoes')}
                >
                  {headerData.mesDataPagamento}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(1, 'dataPagamentoValorAntecipacoes')}
                >
                  {moment(headerData.totalizador.dataPagamento).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(1, 'dataPagamento2ValorAntecipacoes')}
                >
                  {moment(headerData.totalizador.dataPagamento2).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(1, 'dataPagamento3ValorAntecipacoes')}
                >
                  {moment(headerData.totalizador.dataPagamento3).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(1, 'dataPagamento4ValorAntecipacoes')}
                >
                  {moment(headerData.totalizador.dataPagamento4).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(1, 'dataPagamento5ValorAntecipacoes')}
                >
                  {moment(headerData.totalizador.dataPagamento5).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(1, 'dataPagamento6ValorAntecipacoes')}
                >
                  {moment(headerData.totalizador.dataPagamento6).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(1, 'dataPagamento7ValorAntecipacoes')}
                >
                  {moment(headerData.totalizador.dataPagamento7).format('DD/MM/YYYY')}
                </TableCell>
              </TableRow>
            )}
          </TableHead>
          <TableBody>
            {bodyTableAntecipacaoTotal}
            {bodyTableAntecipacao}
          </TableBody>
        </Table>
        {/* Receita Empresa */}
        <Table
          style={{
            margin: '15px',
            backgroundColor: 'white',
            boxShadow:
              '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
          }}
        >
          <TableHead style={{ backgroundColor: '#232C63' }}>
            <TableRow>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} colSpan={10}>
                Receita Empresa
              </TableCell>
            </TableRow>
            {headerData?.itens?.length > 0 && (
              <TableRow style={{ backgroundColor: '#232C63' }}>
                <TableCell
                  colSpan={2}
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(2, 'apelido')}
                >
                  Rede
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(2, 'mesDataPagamentoReceitaEmpresa')}
                >
                  {headerData.mesDataPagamento}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(2, 'dataPagamentoReceitaEmpresa')}
                >
                  {moment(headerData.totalizador.dataPagamento).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(2, 'dataPagamento2ReceitaEmpresa')}
                >
                  {moment(headerData.totalizador.dataPagamento2).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(2, 'dataPagamento3ReceitaEmpresa')}
                >
                  {moment(headerData.totalizador.dataPagamento3).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(2, 'dataPagamento4ReceitaEmpresa')}
                >
                  {moment(headerData.totalizador.dataPagamento4).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(2, 'dataPagamento5ReceitaEmpresa')}
                >
                  {moment(headerData.totalizador.dataPagamento5).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(2, 'dataPagamento6ReceitaEmpresa')}
                >
                  {moment(headerData.totalizador.dataPagamento6).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(2, 'dataPagamento7ReceitaEmpresa')}
                >
                  {moment(headerData.totalizador.dataPagamento7).format('DD/MM/YYYY')}
                </TableCell>
              </TableRow>
            )}
          </TableHead>
          <TableBody>
            {bodyTableEmpresaTotal}
            {bodyTableEmpresa}
          </TableBody>
        </Table>
        {/* Receita Empresa */}
        <Table
          style={{
            margin: '15px',
            backgroundColor: 'white',
            boxShadow:
              '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
          }}
        >
          <TableHead style={{ backgroundColor: '#232C63' }}>
            <TableRow>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} colSpan={10}>
                Receita Capittale
              </TableCell>
            </TableRow>
            {headerData?.itens?.length > 0 && (
              <TableRow style={{ backgroundColor: '#232C63' }}>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(3, 'apelido')}
                >
                  Rede
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(3, 'apelido')}
                >
                  Taxa Atual
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(3, 'mesDataPagamentoReceitaCapittale')}
                >
                  {headerData.mesDataPagamento}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(3, 'dataPagamentoReceitaCapittale')}
                >
                  {moment(headerData.totalizador.dataPagamento).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(3, 'dataPagamento2ReceitaCapittale')}
                >
                  {moment(headerData.totalizador.dataPagamento2).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(3, 'dataPagamento3ReceitaCapittale')}
                >
                  {moment(headerData.totalizador.dataPagamento3).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(3, 'dataPagamento4ReceitaCapittale')}
                >
                  {moment(headerData.totalizador.dataPagamento4).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(3, 'dataPagamento5ReceitaCapittale')}
                >
                  {moment(headerData.totalizador.dataPagamento5).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(3, 'dataPagamento6ReceitaCapittale')}
                >
                  {moment(headerData.totalizador.dataPagamento6).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  onClick={() => sortTable(3, 'dataPagamento7ReceitaCapittale')}
                >
                  {moment(headerData.totalizador.dataPagamento7).format('DD/MM/YYYY')}
                </TableCell>
              </TableRow>
            )}
          </TableHead>
          <TableBody>
            {bodyTableCapittaleTotal}
            {bodyTableCapittale}
          </TableBody>
        </Table>
      </div>
    </>
  );
}

export default TableContent;
